// extracted by mini-css-extract-plugin
module.exports = {"text":"CheckoutPlaceOrderContent_text__1RPRk"};